import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const CrossBrandMenuItemIconDefaultBox = styled.div`
    box-sizing: border-box;
    margin: 0 2rem 0 0;
    width: 2.4rem;
    height: 2.4rem;
`;


export const CrossBrandMenuItemIconBox = styledByTheme(CrossBrandMenuItemIconDefaultBox)
    .apply();